import type { JSX } from 'react';
import React from 'react';

import type { CampaignClass } from '@feathr/blackbox';
import { useAccount } from '@feathr/extender/state';

import type { IType, TCampaignSection } from '../CampaignTypeSelect';
import CampaignTypeSelectSection from '../CampaignTypeSelectSection';

export interface IProps {
  onSelect: (type: CampaignClass) => void;
  types: IType[];
  hasSections?: boolean;
}

function CampaignTypeSelectSections({ hasSections = true, onSelect, types }: IProps): JSX.Element {
  const { isPlatformLite } = useAccount();
  if (!hasSections) {
    return <CampaignTypeSelectSection onSelect={onSelect} types={types} />;
  }

  const sections: TCampaignSection[] = ['expand', 'cultivate', 'understand'];
  const orderedSections: TCampaignSection[] = isPlatformLite
    ? ['cultivate', 'understand', 'expand']
    : sections;

  return (
    <>
      {orderedSections.map((section) => {
        const filteredTypes = types.filter((type) => type.sections?.includes(section));
        if (!filteredTypes.length) {
          return null;
        }
        return (
          <CampaignTypeSelectSection
            key={section}
            onSelect={onSelect}
            section={section}
            types={filteredTypes}
          />
        );
      })}
    </>
  );
}

export default CampaignTypeSelectSections;
